import request from '@/utils/request';
//规则管理列表
export function getRuleManaList(param) {
  return request('/decision/rule', {
    method: 'GET',
    params: param,
  });
}

//新增规则管理列表
export function addRuleManaList(values) {
  return request('/decision/rule', {
    method: 'POST',
    data: values,
  });
}
//编辑规则管理列表
export function editRuleManaList(values) {
  const { parentId } = values || {};
  let url = parentId ? `/decision/rule/${parentId}` : '/decision/rule';
  values['parentId'] = null;
  return request(url, {
    method: 'PUT',
    data: values,
  });
}
//删除规则管理列表
export function deleteRuleManaList(values) {
  const { id } = values || {};
  return request(`/decision/rule/${id}`, {
    method: 'DELETE',
    // data: values,
  });
}
// 导入文件
export function uploadFile(values, id) {
  return request(`/decision/rule/${id}/import`, {
    method: 'POST',
    data: values,
  });
}
// 导出文件
export function exportFieldPackage(id) {
  return request(`/decision/rule/export/${id}`, {
    method: 'GET',
  });
}
